export enum ProfilTypeEnum {
  PLAYER = 'PLAYER',
  STRUCTURE = 'STRUCTURE',
}
